import * as tokens from '@purpur/library/tokens';
import { css } from 'styled-components';

// ThemeProps and ThemedStyledProps are taken from @types/styled-components.
// Once https://github.com/styled-components/styled-components/pull/4126/files is merged import from styled-components
export interface ThemeProps<T> {
    theme: T;
}
export type ThemedStyledProps<P, T> = P & ThemeProps<T>;

const shorthandBreakpoints = {
    S: tokens.purpurBreakpointSm,
    M: tokens.purpurBreakpointMd,
    L: tokens.purpurBreakpointLg,
    XL: tokens.purpurBreakpointXl,
} as const;

const media = (breakpoint: keyof typeof shorthandBreakpoints) => {
    return (...parameters: Parameters<typeof css>) => css`
        @media screen and (min-width: ${shorthandBreakpoints[breakpoint]}) {
            ${css(...parameters)};
        }
    `;
};

export const createTeliaTheme = () => ({
    mixins: {
        media,
    },
});

export type TeliaThemeT = ReturnType<typeof createTeliaTheme>;

export type ThemedProps<P> = ThemedStyledProps<P, TeliaThemeT>;

declare module 'styled-components' {
    export interface DefaultTheme extends TeliaThemeT {}
}
